import { Select, Spin } from 'antd';
import { fetchAllUsers, fetchUser } from '../apis/usersApi';
import { useEffect, useState, useMemo, useCallback } from 'react';
import debounce from 'lodash/debounce';

const SelectUser = ({ className = '', onChange, value }) => {
    const [users, setUsers] = useState([]);
    const [fetching, setFetching] = useState(false);

    const loadUsers = useCallback(async (search = '') => {
        if (!search) {
            setUsers([]);
            return;
        }
        setFetching(true);
        const params = { limit: 50 };
        
        // Determinar si es búsqueda por nombre o por celular (si es numérico)
        if (/^\d+$/.test(search)) {
            params.search_phone = search;
        } else {
            params.search_name = search;
        }
        
        const data = await fetchAllUsers(params);
        setUsers(data.items || []);
        setFetching(false);
    }, []);

    const debouncedSearch = useMemo(() => {
        return debounce((search) => {
            loadUsers(search);
        }, 800);
    }, [loadUsers]);

    // Ensure selected user is in the options list even if no search has been performed
    useEffect(() => {
        if (value && !users.some(u => u.id === value)) {
            const fetchSelected = async () => {
                const user = await fetchUser(value);
                if (user && user.id) {
                    setUsers(prev => {
                        if (prev.some(u => u.id === user.id)) return prev;
                        return [...prev, user];
                    });
                }
            };
            fetchSelected();
        }
    }, [value, users]);

    return (
        <Select
            showSearch
            filterOption={false}
            onSearch={debouncedSearch}
            notFoundContent={fetching ? <Spin size="small" /> : (value ? null : "Escribe para buscar...")}
            onChange={onChange}
            value={value}
            placeholder="Usuario"
            className={className}
            options={users?.map(user => ({
                value: user.id,
                label: `${user.name} ${user.surname_1} ${user.phone || ''}`,
            }))}
        />
    )
}

export default SelectUser;